<!-- @format -->
<div class="swatches hmf-display-flex hmf-align-items-center hmf-m-xs">
	@if (colors() && colors().length) {
		@for (
			color of colors() | slice: 0 : maxColorSwatchesToShow();
			track trackBySwatch($index, color)
		) {
			<plp-components-image-swatch
				class="hmf-m-xxxs"
				radius="0"
				height="44px"
				width="44px"
				[color]="color"
				[imageSrc]="imageSrcMap[color]"
				[imageSwatchHoverDimension]="true"
				[selected]="selectedSwatchColor() === color"
				[isLazy]="isLazy()"
				(mouseover)="setImageColor(color)"
				onFocus="setImageColor(color)"
				(imageSwatchError)="
					handleImageError({ requestedImg: $event, color: color })
				"></plp-components-image-swatch>
		}

		@if (colors().length > maxColorSwatchesToShow()) {
			<button
				hmf-action-text
				variant="secondary"
				class="hmf-m-xxxs underlined-grey-button"
				[ariaLabel]="moreColorsButtonAriaLabel()"
				[linkURL]="assetSeoUrl()"
				[styled]="true"
				(click)="extraColorsClicked($event)">
				+{{ colors().length - maxColorSwatchesToShow() }}
			</button>
		}
	}
</div>
